/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { isMobile } from "react-device-detect";
import { TypeAnimation } from "react-type-animation";
import { useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";

const MainBanner = () => {
  const navigate = useNavigate();
  const goToIDO = () => {
    navigate("/launchpads");
  };
  const goToAir = () => {
    // navigate('/airdrop');
  };
  const goToDoc = () => {
    window.open("https://docs.tinyblock.io");
  };
  const images = [
    "/images/eth.png",
    "/images/bnb.png",
    "/images/avax.png",
    "/images/poly.png",
    "/images/arb.png",
    "/images/base.png",
    "/images/mint.png",
    "/images/5ire.png",
    "/images/hela.png",
  ];

  return (
    <>
      <div className="main-banner-home">
        <div className="container-fluid">
          <div className="wrap-banner">
            <div className="title">
              {isMobile ? (
                <>
                  TinyBlock - Fuel your Launch <br /> Fund your Future
                </>
              ) : (
                <>
                  TinyBlock - Fuel your Launch
                  <TypeAnimation
                    style={{ whiteSpace: "pre-line", display: "block" }}
                    sequence={[`Fund your Future`, 2000, "Fund", 500]}
                    wrapper="span"
                    speed={30}
                    cursor={false}
                    repeat={Infinity}
                  />
                </>
              )}
            </div>

            <div className="desc">
              A next-gen Web3 launchpad empowering early-stage projects to raise
              funds & grow, while giving investors early access to vetted token
              launches.
            </div>
            <div className="group-button">
              <div className="btn-item">
                <button className="main-button res" onClick={goToIDO}>
                  Join IDOs
                </button>
              </div>
              <div className="btn-item">
                <button className="button-control res" onClick={goToAir}>
                  <img src="/images/air-btn.png" alt="" /> Hunt Airdrops
                </button>
              </div>
              <div className="btn-item">
                <button className="button-control res" onClick={goToDoc}>
                  <img src="/images/do-btn.png" alt="" />
                  Explore The Docs
                </button>
              </div>
            </div>
            <div className="text-chain-sp">Supported Blockchain</div>
            <div className="chain-support !mb-0 md:pb-12">
              <div className="marquee-container">
                <div className="marquee-wrapper">
                  <Marquee
                    className="custom-marquee"
                    direction="left"
                    gradient
                    pauseOnHover
                    speed={50}
                    loop={0}
                    autoFill
                    gradientWidth={150}
                  >
                    {images.map((item, index) => (
                      <div className="marquee-item">
                        <img
                          key={index}
                          src={images[index]}
                          alt={`Image ${index + 1}`}
                        />
                      </div>
                    ))}
                  </Marquee>
                </div>
              </div>
            </div>
            <div className="box-banner-img">
              <video
                playsInline
                webkit-playsinline
                autoPlay
                muted
                loop
                style={{ width: "100%", height: "auto" }}
              >
                <source
                  src="https://tinyblock.s3.ap-southeast-1.amazonaws.com/home.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MainBanner;
